import { Stack, Typography } from '@mui/material';
import SwitchButton from '~/components/common/SwitchButton';
import themes from '~/themes';

type IncludePickupTaskProps = {
  skipPickup?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const IncludePickupTask: React.FC<IncludePickupTaskProps> = ({
  skipPickup,
  onChange,
}) => (
  <Stack sx={{ background: themes.bg.white, borderRadius: '8px', p: 1.6 }}>
    <Typography fontWeight={500} fontSize={16}>
      Include Pickup Task
    </Typography>
    <Typography my={0.8}>
      Drivers will receive a pickup task on the Driver app, which they must
      complete before starting the corresponding dropoff task.
    </Typography>
    <SwitchButton
      name='skip_pickup'
      noText
      checked={!skipPickup}
      onChange={onChange}
    />
  </Stack>
);
